import { render, staticRenderFns } from "./feeDetail.vue?vue&type=template&id=3825634b&scoped=true"
import script from "./feeDetail.vue?vue&type=script&lang=js"
export * from "./feeDetail.vue?vue&type=script&lang=js"
import style0 from "./feeDetail.vue?vue&type=style&index=0&id=3825634b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3825634b",
  null
  
)

export default component.exports